import React from "react";

import { SHOP } from "../../data/content";
import ArtworkCard from "./ArtworkCard";

//Grid of artworks, showing a page at a time with "Load More" (as on Wix)
const ArtworkGrid = ({ artworks, pageSize = SHOP.PAGE_SIZE }) => {
  const [count, setCount] = React.useState(pageSize);
  const gridRef = React.useRef(null);

  //Start again when the list changes (another artist / category)
  React.useEffect(() => {
    setCount(pageSize);
  }, [artworks, pageSize]);

  const loadMore = () => {
    const firstNew = count;
    setCount(count + pageSize);
    //Move keyboard focus to the first new artwork so keyboard users carry on from there
    window.requestAnimationFrame(() => {
      const link = gridRef.current && gridRef.current.querySelectorAll("a")[firstNew];
      if (link) {
        link.focus({ preventScroll: true });
      }
    });
  };

  return (
    <React.Fragment>
      <ul
        ref={gridRef}
        className={"artwork-grid"}
      >
        {artworks.slice(0, count).map((artwork) => (
          <li key={artwork.slug}>
            <ArtworkCard artwork={artwork} />
          </li>
        ))}
      </ul>
      {count < artworks.length ? (
        <div className={"artwork-grid-more"}>
          <button
            type={"button"}
            className={"btn is-outline"}
            onClick={loadMore}
          >
            Load More
          </button>
          <p className={"artwork-grid-count"}>
            Showing {count} of {artworks.length}
          </p>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default ArtworkGrid;
